import { getScreenWidth } from './getScreenWidth.js';

// The public site header collapses into the avatar menu at 768px. The Venue Cabinet header needs
// more room than that - several of its tabs carry a count or a New badge, which wrap onto a second
// line below 992px - so there the tab bar waits for 992px and the avatar menu carries the whole
// navigation up to it. The public header does the same wherever the "Browse spaces" menu is on offer,
// which the design keeps in the avatar menu on a tablet. The SCSS half of this lives under
// .vc-navigation and .ds-header--browse-spaces in _base-header.scss.
const MOBILE_BREAKPOINT = 768;
const VC_MOBILE_BREAKPOINT = 992;

// The Venue Cabinet header is rendered by Twig, so it is in the document before any of this runs;
// the public header is marked by initBrowseSpaces(), which the navbar calls before anything below.
const TABLET_MOBILE_HEADER_SELECTOR = '.vc-navigation, .ds-header--browse-spaces';

function getMobileBreakpoint() {
  return document.querySelector(TABLET_MOBILE_HEADER_SELECTOR) ? VC_MOBILE_BREAKPOINT : MOBILE_BREAKPOINT;
}

// Below the tab bar the avatar menu is the only navigation on the page, so it has to carry the tabs
// as well as the account links.
export function isTabBarVisible() {
  return getScreenWidth() >= VC_MOBILE_BREAKPOINT;
}

export function isAvatarMenuMobile() {
  return getScreenWidth() < getMobileBreakpoint();
}

// The navbar only rebuilds itself when a resize crosses one of the configured breakpoints, so the
// 992px one has to be among them or the menu keeps whichever form the page was loaded at.
export function withAvatarMenuMobileBreakpoint(breakpoints) {
  const breakpoint = getMobileBreakpoint();

  return breakpoints.includes(breakpoint) ? breakpoints : [...breakpoints, breakpoint];
}
